"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButtonMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _constants = require("../../constants");
var _iconSizeMixin = require("../iconSizeMixin");
var _spaceMixin = require("../spaceMixin");
var _ButtonMixin = require("./ButtonMixin");
var SquareIconButton = function SquareIconButton(props) {
  var size = props.size;
  return (0, _styledToken.default)({
    buttonSize: "IconButton.size." + size
  }, function (_ref) {
    var buttonSize = _ref.buttonSize;
    return (0, _styledComponents.css)(["", " height:", "px;width:", "px;display:flex;align-items:center;justify-content:center;padding:", ";&[aria-pressed='true']:disabled{opacity:1;}"], _ButtonMixin.ButtonMixin, buttonSize, buttonSize, (0, _spaceMixin.spaceMixin)(size === 'xs' ? 'xs' : 'sm')(props));
  });
};
var CircleIconButton = function CircleIconButton() {
  return (0, _styledToken.default)({
    borderRadius: 'IconButton.circle.borderRadius'
  }, function (_ref2) {
    var borderRadius = _ref2.borderRadius;
    return (0, _styledComponents.css)(["", " border-radius:", ";"], SquareIconButton, borderRadius);
  });
};

/** @class IconButtonMixin */
/** @method */
var IconButtonMixin = function IconButtonMixin(props) {
  var appearance = props.appearance,
    size = props.size;
  return (0, _styledComponents.css)(["", ";span{", "}"], appearance === _constants.BUTTON_SHAPES.circle ? CircleIconButton : SquareIconButton, (0, _iconSizeMixin.iconSizeMixin)(Object.assign({}, props, {
    iconSize: size === 'xs' || size === 'sm' ? 'xs' : 'sm'
  })));
};
exports.IconButtonMixin = IconButtonMixin;